import React, { useEffect, useState } from 'react';
import { templeTrust_detail } from '../api/DonationBillApi/DonationCillapi';
import { useParams } from 'react-router';

const PublicHeaderComponent = ({ therdTitle, templeUuid: propTempleUuid }) => {
  const { templeUuid: routeTempleUuid } = useParams();
  const templeUuid = propTempleUuid || routeTempleUuid;
  const [templeDetail, setTempleDetail] = useState({});

  useEffect(() => {
    if (!templeUuid) return;
    const fetchTemple = async () => {
      try {
        const { data } = await templeTrust_detail(templeUuid);
        if (data.status === 200) {
          setTempleDetail({
            ...data.payload.data
          });
        }
      } catch (error) {
        console.log('error >> ', error);
      }
    };
    fetchTemple();
  }, [templeUuid]);

  const templeName = templeDetail?.templeName || 'શ્રી સ્વામિનારાયણ મંદિર';
  const templeAddress = templeDetail?.address
    ? `${templeDetail.address}${templeDetail.city ? `, ${templeDetail.city}` : ''}${templeDetail.state ? `, ${templeDetail.state}` : ''}${templeDetail.country ? `, ${templeDetail.country}` : ''}`
    : '';

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '22px',
        alignItems: 'center',
        textAlign: 'center',
        padding: '12px 16px 4px 16px'
      }}
    >
      {/* Traditional Line */}
      <div
        style={{
          fontSize: '13px',
          letterSpacing: '2.5px',
          color: '#dc2626',
          fontWeight: '700',
          textTransform: 'uppercase',
          marginBottom: '6px'
        }}
      >
        || श्री स्वामिनारायणो विजयतेतराम् ||
      </div>

      {/* Temple Name */}
      <h2
        style={{
          fontSize: '24px',
          letterSpacing: '1px',
          color: therdTitle || '#0f172a',
          fontWeight: '800',
          margin: '0 0 6px 0',
          lineHeight: '1.3'
        }}
      >
        {templeName}
      </h2>

      {/* Temple Address */}
      {templeAddress ? (
        <div
          style={{
            fontSize: '14px',
            color: '#64748b',
            maxWidth: '650px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '6px'
          }}
        >
          <span>📍</span>
          <span>{templeAddress}</span>
        </div>
      ) : null}
    </div>
  );
};

export default PublicHeaderComponent;
